import {StepController} from 'MWC';
import FormComponent from '../../views/orderAction/form.c';
import ResultComponent from '../../views/orderAction/result.c';
import React from 'react';
import css from '../../less/order/main.m.less';

export default function template() {
    return (
        <div className={css.root}>
            <StepController>
                <FormComponent {...this.props} id="form" model={this.formModel} />
                <ResultComponent {...this.props} id="result" />
            </StepController>
        </div>
    );
}
